import { createContext } from 'react'
import { User } from '@schema/user'
import { ClientAuthState } from '@based/sdk'

type UserContextType = {
  user: User | null
  authState: ClientAuthState
  isAuthenticated: boolean
  isLoading: boolean
}

export const UserContext = createContext<UserContextType>({
  user: null,
  authState: {},
  isAuthenticated: false,
  isLoading: true,
})
